import { useState, useCallback } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const useInterviewStatusCheck = (
  encoded_zoho_lead_id,
  encoded_interview_link_send_count,
) => {
  const [checking, setChecking] = useState(false);
  const navigate = useNavigate();

  const checkStatus = useCallback(async () => {
    if (!encoded_zoho_lead_id || !encoded_interview_link_send_count) {
      return { valid: false, reason: "missing_params" };
    }

    setChecking(true);
    try {
      const formData = new FormData();
      formData.append("zoho_lead_id", encoded_zoho_lead_id);
      formData.append(
        "encoded_interview_link_send_count",
        encoded_interview_link_send_count,
      );

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}interveiw-section/check-interview-status/`,
        formData,
      );

      if (response.data.is_expired || response.data.is_time_expired) {
        navigate(`/expired/${encoded_zoho_lead_id}`, { replace: true });
        return { valid: false, reason: "expired" };
      }

      if (response.data.interview_attend) {
        navigate(
          `/interviewsubmitted?lead=${encoded_zoho_lead_id}&link=${encoded_interview_link_send_count}&reason=ALREADY_COMPLETED`,
          { replace: true },
        );
        return { valid: false, reason: "already_attended" };
      }

      return { valid: true };
    } catch (error) {
      if (error.response?.status === 410 || error.response?.status === 404) {
        navigate(`/expired/${encoded_zoho_lead_id}`, { replace: true });
        return { valid: false, reason: "expired" };
      }
      console.error("Status check error:", error);
      return { valid: false, reason: "error" };
    } finally {
      setChecking(false);
    }
  }, [encoded_zoho_lead_id, encoded_interview_link_send_count, navigate]);

  return { checkStatus, checking };
};

export default useInterviewStatusCheck;
